import React, { useRef } from 'react';
import reading from '../../assets/reading.svg';
import './about.css';

const About = () => {
  const ref = useRef(null);

  return (
    <div ref={ref}>
      <div
        id="about"
        className="w-full md:h-[700px] 2xl:h-[900px] bg-white py-20 2xl:py-40 px-4 flex items-center"
      >
        <div className="max-w-[1240px] mx-auto grid md:grid-cols-2 gap-10 items-stretch">

          <div className="h-full">
            <img
              className="h-full w-full 2xl:ml-[-100px] object-contain"
              src={reading}
              alt="Student learning illustration"
            />
          </div>

          <div className="flex flex-col justify-center">
            <p className="text-transparent bg-gradient-to-r from-teal-400 via-blue-400 to-blue-600 bg-clip-text font-bold">
              ABOUT EDUBAHAMAS
            </p>

            <h1 className="md:text-3xl sm:text-2xl font-bold py-2 2xl:mb-[25px]">
              Made for Bahamian students. Built for better results.
            </h1>

            <p className="text-[grey] 2xl:w-[650px] leading-relaxed mb-2">
              EduBahamas helps Bahamian students prepare for BGCSE and BJC with a
              study experience that feels clear, guided, and motivating — not
              overwhelming.
            </p>
            <p className="text-[grey] 2xl:w-[650px] leading-relaxed">
              Founded by a Bahamian student, our mission is simple: raise the
              national average one “A” at a time by helping you build real
              confidence before exam day.
            </p>

            <div className="mt-8 2xl:w-[650px]">
              <div className="rounded-2xl py-5">
                <p className="text-center text-xs font-semibold tracking-widest text-black">
                  WHAT MAKES US DIFFERENT
                </p>

                <div className="mt-4 grid grid-cols-1 gap-1">
                  <div className="rounded-xl bg-white border border-gray-200 p-3">
                    <p className="text-sm font-semibold text-gray-900">
                      Progress that matters
                    </p>
                    <p className="text-xs text-gray-600 mt-1 leading-relaxed">
                      Track what you’ve mastered — not just what you attempted.
                    </p>
                  </div>

                  <div className="rounded-xl bg-white border border-gray-200 p-4">
                    <p className="text-sm font-semibold text-gray-900">
                      Guided or Explore mode
                    </p>
                    <p className="text-xs text-gray-600 mt-1 leading-relaxed">
                      Learn step-by-step, or jump to what you need right now.
                    </p>
                  </div>

                  <div className="rounded-xl bg-white border border-gray-200 p-4">
                    <p className="text-sm font-semibold text-gray-900">
                      Updated Weekly
                    </p>
                    <p className="text-xs text-gray-600 mt-1 leading-relaxed">
                      Questions and subjects updated every Sunday
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
